var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVennWireComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 348.0 348.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l348.0 0l0 348.0l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m-6.0 0l348.0 0l0 347.9685l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.5433073 5.1642733l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.5433073 5.1642733l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m253.95013 28.824146l0 29.165356l-225.7323 0l0 -29.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.95013 28.824146l0 29.165356l-225.7323 0l0 -29.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m187.68373 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.695221 1.54459 -3.9944153 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m187.68373 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.695221 1.54459 -3.9944153 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m153.83989 35.170605l0 0c4.9923096 0 9.039383 3.687481 9.039383 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.647583 5.8238907c-1.6952057 1.54459 -3.9944 2.4123306 -6.3918 2.4123306l0 0c-4.9922943 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.0470734 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m153.83989 35.170605l0 0c4.9923096 0 9.039383 3.687481 9.039383 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.647583 5.8238907c-1.6952057 1.54459 -3.9944 2.4123306 -6.3918 2.4123306l0 0c-4.9922943 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.0470734 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m119.99606 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.6952133 1.54459 -3.9944077 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m119.99606 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.6952133 1.54459 -3.9944077 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m52.3084 35.170605l0 0c4.9923058 0 9.0393715 3.687481 9.0393715 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475716 5.8238907c-1.6952095 1.54459 -3.9944115 2.4123306 -6.3918 2.4123306l0 0c-4.9923058 0 -9.0393715 -3.687481 -9.0393715 -8.236221l0 0c0 -4.5487366 4.0470657 -8.2362175 9.0393715 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m52.3084 35.170605l0 0c4.9923058 0 9.0393715 3.687481 9.0393715 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475716 5.8238907c-1.6952095 1.54459 -3.9944115 2.4123306 -6.3918 2.4123306l0 0c-4.9923058 0 -9.0393715 -3.687481 -9.0393715 -8.236221l0 0c0 -4.5487366 4.0470657 -8.2362175 9.0393715 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m86.15223 35.170605l0 0c4.9923096 0 9.039375 3.687481 9.039375 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475754 5.8238907c-1.6952057 1.54459 -3.9944077 2.4123306 -6.3918 2.4123306l0 0c-4.992302 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.0470657 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m86.15223 35.170605l0 0c4.9923096 0 9.039375 3.687481 9.039375 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475754 5.8238907c-1.6952057 1.54459 -3.9944077 2.4123306 -6.3918 2.4123306l0 0c-4.992302 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.0470657 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m221.52756 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.6952057 1.54459 -3.9944153 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m221.52756 35.170605l0 0c4.9923096 0 9.039368 3.687481 9.039368 8.2362175l0 0c0 2.1843834 -0.95236206 4.279297 -2.6475677 5.8238907c-1.6952057 1.54459 -3.9944153 2.4123306 -6.3918 2.4123306l0 0c-4.9923096 0 -9.039368 -3.687481 -9.039368 -8.236221l0 0c0 -4.5487366 4.047058 -8.2362175 9.039368 -8.2362175z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m253.95013 57.989502l0 29.165352l-225.7323 0l0 -29.165352z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.95013 57.989502l0 29.165352l-225.7323 0l0 -29.165352z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m302.3832 249.86876l0 29.16536l-274.17325 0l0 -29.16536z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m302.3832 249.86876l0 29.16536l-274.17325 0l0 -29.16536z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m302.3832 279.03412l0 43.811035l-274.17325 0l0 -43.811035z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m302.3832 279.03412l0 43.811035l-274.17325 0l0 -43.811035z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m33.559055 282.4042l31.5117 0l5.653656 5.653656l0 28.267609l0 0l-31.5117 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m33.559055 282.4042l31.5117 0l5.653656 5.653656l0 28.267609l0 0l-31.5117 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m80.031586 282.4042l31.511696 0l5.653656 5.653656l0 28.267609l0 0l-31.511696 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m80.031586 282.4042l31.511696 0l5.653656 5.653656l0 28.267609l0 0l-31.511696 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m126.50421 282.4042l32.55107 0l5.653656 5.653656l0 28.267609l0 0l-32.55107 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m126.50421 282.4042l32.55107 0l5.653656 5.653656l0 28.267609l0 0l-32.55107 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m172.97348 282.4042l32.55107 0l5.653656 5.653656l0 28.267609l0 0l-32.55107 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m172.97348 282.4042l32.55107 0l5.653656 5.653656l0 28.267609l0 0l-32.55107 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m219.44604 282.4042l32.55107 0l5.6536713 5.653656l0 28.267609l0 0l-32.551086 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m219.44604 282.4042l32.55107 0l5.6536713 5.653656l0 28.267609l0 0l-32.551086 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m52.199474 73.362206c1.7602768 17.586403 -6.1128616 34.99501 -6.1128616 52.66929c0 21.01828 0.6147461 42.865906 7.994751 62.54593c2.1437645 5.7167053 8.528656 9.897568 8.934383 15.989502c1.3119125 19.698273 -10.346455 38.57306 -10.346455 58.314972",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m52.199474 73.362206c1.7602768 17.586403 -6.1128616 34.99501 -6.1128616 52.66929c0 21.01828 0.6147461 42.865906 7.994751 62.54593c2.1437645 5.7167053 8.528656 9.897568 8.934383 15.989502c1.3119125 19.698273 -10.346455 38.57306 -10.346455 58.314972",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m85.11743 72.42257c18.780602 7.5108414 0.36827087 40.51551 -1.4094467 60.66404c-2.582077 29.265121 20.188087 58.257324 14.107613 87.0c-2.2489471 10.63089 -13.744919 18.323273 -14.577431 29.157486c-0.43315125 5.6369934 6.97567 9.658218 12.225723 11.755905",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m85.11743 72.42257c18.780602 7.5108414 0.36827087 40.51551 -1.4094467 60.66404c-2.582077 29.265121 20.188087 58.257324 14.107613 87.0c-2.2489471 10.63089 -13.744919 18.323273 -14.577431 29.157486c-0.43315125 5.6369934 6.97567 9.658218 12.225723 11.755905",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m120.85827 70.07163c21.047768 -1.7515335 15.186165 41.102646 12.698158 62.07612c-2.5116272 21.172668 22.012848 38.876495 21.632553 60.194214c-0.4462738 25.016312 -22.602036 55.552017 -6.5826874 74.77165",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m120.85827 70.07163c21.047768 -1.7515335 15.186165 41.102646 12.698158 62.07612c-2.5116272 21.172668 22.012848 38.876495 21.632553 60.194214c-0.4462738 25.016312 -22.602036 55.552017 -6.5826874 74.77165",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m153.30708 74.77428c13.078888 12.306007 12.2812195 33.98622 15.049866 51.72966c3.9136505 25.081268 11.755905 49.856705 11.755905 75.24147c0 22.117126 -7.5283356 46.522034 2.351715 66.30971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m153.30708 74.77428c13.078888 12.306007 12.2812195 33.98622 15.049866 51.72966c3.9136505 25.081268 11.755905 49.856705 11.755905 75.24147c0 22.117126 -7.5283356 46.522034 2.351715 66.30971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m193.75066 77.5958c18.19191 40.62802 36.22545 82.755974 41.38321 126.97112c2.4362183 20.88469 -2.8215332 41.989456 -2.8215332 63.015747",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m193.75066 77.5958c18.19191 40.62802 36.22545 82.755974 41.38321 126.97112c2.4362183 20.88469 -2.8215332 41.989456 -2.8215332 63.015747",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m216.32545 65.367455c10.928528 15.304817 27.312088 26.697128 36.209976 43.26509c15.0729065 28.065895 7.969574 63.26455 14.107605 94.52494c4.190338 21.340836 18.123169 41.955444 15.049866 63.48555",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m216.32545 65.367455c10.928528 15.304817 27.312088 26.697128 36.209976 43.26509c15.0729065 28.065895 7.969574 63.26455 14.107605 94.52494c4.190338 21.340836 18.123169 41.955444 15.049866 63.48555",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m262.65878 282.4042l28.740051 0l5.653656 5.653656l0 28.267609l0 0l-28.740051 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.65878 282.4042l28.740051 0l5.653656 5.653656l0 28.267609l0 0l-28.740051 0l-5.653656 -5.653656l0 -28.267609z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m32.519684 275.53543l38.204727 0l0 43.811035l-38.204727 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m41.519684 286.95044l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m42.738434 296.4192l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m79.51181 275.43307l38.204727 0l0 43.811005l-38.204727 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m88.51181 286.84808l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m89.73056 296.31683l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m126.24278 275.43307l38.204727 0l0 43.811005l-38.204727 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m135.24278 286.84808l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m136.46153 296.31683l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m172.84514 275.43307l38.204727 0l0 43.811005l-38.204727 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m181.84514 286.84808l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m183.06389 296.31683l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m215.24803 274.021l38.204727 0l0 43.811035l-38.204727 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.24803 285.436l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m225.46678 294.90475l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m257.6509 275.53543l38.204742 0l0 43.811035l-38.204742 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m266.6509 286.95044l24.0 0l0 24.0l-24.0 0l0 -24.0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "m267.86966 296.4192l8.15625 0l2.53125 -8.0625l2.53125 8.0625l8.15625 0l-6.65625 4.59375l2.4375 7.78125l-6.46875 -4.78125l-6.46875 4.78125l2.4375 -7.78125l-6.65625 -4.59375z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVennWireComponent);
export default __webpack_public_path__ + "static/media/VennWireComponent.d3d96ed271c72c4a28963a76cde6663c.svg";
export { ForwardRef as ReactComponent };